// extracted by mini-css-extract-plugin
export var aboutBody = "AboutBody-module--aboutBody--8e5c9";
export var aboutBodyContainer = "AboutBody-module--aboutBodyContainer--c4480";
export var image = "AboutBody-module--image--58216";
export var links = "AboutBody-module--links--1ac26";